/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TextbookType = "CORE_TEXTBOOK" | "LEGACY" | "SKILLS_BOOK";
export type FreeTextbooksTopicSubtopicTree_topic = {
    readonly id: string;
    readonly title: string;
    readonly badgeUrl: string;
    readonly syllabus: {
        readonly textbookType: TextbookType;
    };
};
export type FreeTextbooksTopicSubtopicTree_topic$data = FreeTextbooksTopicSubtopicTree_topic;
export type FreeTextbooksTopicSubtopicTree_topic$key = {
    readonly " $data"?: FreeTextbooksTopicSubtopicTree_topic$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FreeTextbooksTopicSubtopicTree_topic">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "mask": false
  },
  "name": "FreeTextbooksTopicSubtopicTree_topic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "badgeUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FreeTextbookSyllabus",
      "kind": "LinkedField",
      "name": "syllabus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textbookType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FreeTextbookTopic",
  "abstractKey": null
};
(node as any).hash = '6d5793994c53d7c1989f6881aea99348';
export default node;
